import { createContext } from 'react';

interface IStoreContext {
  store: {
    user: null | {
      avatar?: string;
      email?: string;
      firstName?: string;
      gender?: string;
      lastName?: string;
      mobilePhone?: string;
      postalCode?: string;
      birthday?: string;
      code?: string;
    };
  };
  setUser: (x: object) => void;
}

export const storeContext = createContext<IStoreContext | null>(null);
